import { PrimitiveType, FormatXMLElementFn } from 'intl-messageformat';
import { useIntl } from 'react-intl';

export const useTranslation = () => {
  const { formatMessage } = useIntl();

  return (
    id: string,
    param:
      | Record<string, PrimitiveType | FormatXMLElementFn<string, string>>
      | undefined = undefined,
  ) => {
    return formatMessage({ id: id || 'empty' }, param);
  };
};
